const DAYS = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
const DAYS_SHORT = ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"];
const MONTHS = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
const MONTHS_SHORT = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];

const toUTC = (ds) => {
  const [y, m, d] = ds.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d));
};

export const fmtDate = (ds) => {
  const dt = toUTC(ds);
  return `${DAYS[dt.getUTCDay()]}, ${dt.getUTCDate()} ${MONTHS[dt.getUTCMonth()]} ${dt.getUTCFullYear()}`;
};
export const fmtShort = (ds) => {
  const dt = toUTC(ds);
  return `${dt.getUTCDate()} ${MONTHS_SHORT[dt.getUTCMonth()]}`;
};
export const dayShort = (ds) => DAYS_SHORT[toUTC(ds).getUTCDay()];
export const isoDow = (ds) => toUTC(ds).getUTCDay() || 7;
export const addDays = (ds, n) => {
  const dt = toUTC(ds);
  dt.setUTCDate(dt.getUTCDate() + n);
  return dt.toISOString().slice(0, 10);
};
export const daysBetween = (a, b) => Math.round((toUTC(b) - toUTC(a)) / 86400000);
export const hmWIB = (iso) =>
  iso ? new Date(iso).toLocaleTimeString("id-ID", { timeZone: "Asia/Jakarta", hour: "2-digit", minute: "2-digit" }) : "–";
export const dateWIB = (iso) =>
  new Date(iso).toLocaleDateString("en-CA", { timeZone: "Asia/Jakarta" });
export const fmtNum = (n) => new Intl.NumberFormat("id-ID").format(n || 0);
export const dot = (t) => (t || "").replace(":", ".");
export const lines = (t) => (t || "").split("\n").filter(Boolean);
export const pct = (v) => (v === null || v === undefined ? "–" : `${v}%`);
export const STATUS = {
  ontrack: { label: "On track", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  delay: { label: "Delay", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  blocked: { label: "Blocked", cls: "bg-red-50 text-brand border-red-200" },
};
export const WEEKDAYS = [
  [1, "Senin"], [2, "Selasa"], [3, "Rabu"], [4, "Kamis"], [5, "Jumat"], [6, "Sabtu"], [7, "Minggu"],
];
